import axios from 'axios'

export default {
  state: {
    student: {},
    schedule: {
      enrolled: [],
      waiting: []
    },
    httpResponse: {
      code: 0,
      message: ''
    }
  },
  mutations: {
    setEnrollmentStudent(state, payload) {
      state.student = payload
    },
    setEnrollmentSchedule (state, payload) {
      state.schedule = payload
    },
    clearEnrollmentSchedule(state) {
      state.schedule.enrolled = []
      state.schedule.waiting = []
    },
    setEnrollmentHttpResponse(state, payload) {
      state.httpResponse.code = payload.status
      state.httpResponse.message = payload.data.message
    },
    clearEnrollmentHttpResponse(state) {
      state.httpResponse.code = 0
      state.httpResponse.message = ''
    }
  },
  actions: {
    addClass({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/schedules/${payload.course_id}/${payload.student_id}/enroll`, payload).then((response) => {
            commit('setEnrollmentSchedule', response.data.schedule)
            commit('setSemesterCourses', response.data.courses)
            commit('setEnrollmentHttpResponse', response)
            resolve()
          })
          .catch((error) => {
            dispatch('checkToken', error).then(() => {
              commit('setSemesterCourses', error.response.data.courses)
              commit('setEnrollmentHttpResponse', error.response)
              reject()
            })
          })
      })
    },
    addWaitlistEntry({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/schedules/${payload.course_id}/${payload.student_id}/waitlist`, payload).then((response) => {
          commit('setEnrollmentSchedule', response.data.schedule)
          commit('setSemesterCourses', response.data.courses)
          commit('setEnrollmentHttpResponse', response)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setSemesterCourses', error.response.data.courses)
            commit('setEnrollmentHttpResponse', error.response)
            reject()
          })
        })
      })
    },
    removeFromWaitlist ({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/schedules/${payload.course_id}/${payload.student_id}/waitlist/remove`, payload).then((response) => {
          commit('setEnrollmentSchedule', response.data.schedule)
          commit('setSemesterCourses', response.data.courses)
          commit('setEnrollmentHttpResponse', response)
          resolve(response)
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setSemesterCourses', error.response.data.courses)
            commit('setEnrollmentHttpResponse', error.response)
            reject()
          })
        })
      })
    },
    dropClass({commit, dispatch}, payload) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/schedules/${payload.course_id}/${payload.student_id}/drop`, payload).then((response) => {
          commit('setEnrollmentSchedule', response.data.schedule)
          commit('setSemesterCourses', response.data.courses)
          commit('setEnrollmentHttpResponse', response)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setSemesterCourses', error.response.data.courses)
            commit('setEnrollmentHttpResponse', error.response)
            reject()
          })
        })
      })
    },
    // must return a promise, otherwise bug occurs when parent navigates from dashboard to enrollment page
    // the two calls to student schedule need to be synchronous
    // getStudentSchedule({ commit, dispatch }, id) {
    //   return new Promise((resolve, reject) => {
    //     axios.get('/api/students/' + id + '/schedule').then((response) => {
    //       commit('setEnrollmentSchedule', response.data.schedule)
    //       resolve()
    //     })
    //     .catch((error) => {
    //       dispatch('checkToken', error).then(() => reject(error))
    //     })
    //   })
    // },
    getStudentSchedule({ commit, dispatch, state }, semester) {
      axios.get('/api/students/' + state.student.id + '/schedule', { params: { semester: semester } }).then((response) => {
        commit('setEnrollmentSchedule', response.data.schedule)
      })
      .catch((error) => {
        dispatch('checkToken', error).then(() => console.log(error))
      })
    },
  },
  getters: {
    formattedStudentSchedule (state) {
      const response = { m: [], t: [], w: [], f: [] }
      state.schedule.enrolled.forEach((c) => {
        switch (c.days) {
          case 'M':
            response.m.push(c)
            break
          case 'T/TH':
            response.t.push(c)
            break
          case 'W':
            response.w.push(c)
            break
          case 'F':
            response.f.push(c)
            break
        }
      })

      // so printed schecule will be ordered by section #
      response.m.sort((a,b) => a.section - b.section)
      response.t.sort((a,b) => a.section - b.section)
      response.w.sort((a,b) => a.section - b.section)
      response.f.sort((a,b) => a.section - b.section)

      return response
    }
  }
}


